<div class="main-content" *ngIf="newUI">
  <!-- START REDESING -->
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
<!--           <div class="card-header card/-header-primary card-header-icon">
            <div class="card-icon">
              <i class="material-icons">person</i>
            </div>
            <h4 class="card-title">Leads</h4>
          </div> -->

          <div class="card-body">
            <!------------------------ START CARD-BODY -------------------->
            <section class="container-header-table">
              <div class="container-header-table-buttons">
                <!-- <button
                  class="gts-btn-select-primary-outline btn-header-table"
                  matRipple
                  style="min-width: auto"
                  [matMenuTriggerFor]="btnSelectStatus"
                >
                  <span class="gts-btn-text"
                    >status: <b>{{ assigned }}</b></span
                  >
                  <span class="gts-btn-select-icon">expand_more</span>
                </button> -->
                <app-button-select
                  [options]="optionsButtonSelect"
                  [(selected)]="optionSelectMenuTrigger"
                  (selectedChange)="menuTriggerToShow($event)"
                  [label]="'Status'"
                >
                </app-button-select>
                <div style="display: flex">
                  <div class="input-date-header">
                    <mat-date-range-input
                      [rangePicker]="picker"
                      style="background-color: #f7f7f7"
                    >
                      <input
                        [(ngModel)]="sinceDate"
                        matStartDate
                        placeholder="Start date"
                        style="background-color: #f7f7f7"
                      />
                      <input
                        [(ngModel)]="toDate"
                        matEndDate
                        placeholder="End date"
                        style="background-color: #f7f7f7"
                      />
                    </mat-date-range-input>
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                  </div>
                  <button
                    class="gts-btn-primary"
                    matRipple
                    (click)="getAllContactsFormByDate()"
                    [disabled]="sinceDate == null || searching"
                  >
                    <span class="gts-btn-icon" *ngIf="!searching">search</span>
                    <i
                      class="fa fa-circle-o-notch fa-spin fa-1x fa-fw"
                      *ngIf="searching"
                    ></i>
                  </button>
                </div>
              </div>
              <div class="container-header-table-buttons">
                <div class="itad-btn-with-status">
                  <span
                    class="itad-btn-status-badge"
                    [ngClass]="{
                      'itad-badge-active': statusHDMode == 1,
                      'itad-badge-inactive': statusHDMode == 0
                    }"
                  ></span>
                  <button
                    class="gts-btn-primary-outline btn-header-table"
                    matRipple
                    (click)="showModalHDMode()"
                  >
                    <span class="gts-btn-icon-left">beach_access</span
                    ><span class="gts-btn-text-uppercase">hd</span
                    ><span class="gts-btn-text">mode</span>
                  </button>
                </div>

                <button
                  class="gts-btn-primary btn-header-table"
                  matRipple
                  (click)="openModal()"
                >
                  <span class="gts-btn-icon-left">add</span
                  ><span class="gts-btn-text">lead</span>
                </button>
              </div>
            </section>

            <div style="position: relative">
              <!-- BTN FLOAT -->
              <section
              [ngClass]="getClass()"
                *ngIf="bulkNewsletterContacts.length > 0 || bulk.length > 0"
              >
                <div style="display: flex">
                  <div class="title-actions">
                    <b class="gts-btn-text" *ngIf="assigned !== 'newsletter'"
                      >{{ bulk.length }} Selected:
                    </b>
                    <b class="gts-btn-text" *ngIf="assigned == 'newsletter'"
                      >{{ bulkNewsletterContacts.length }} Selected:
                    </b>
                  </div>

                  <button
                    class="gts-btn-primary-outline-actions"
                    matRipple
                    matTooltip="Assign Selected Leads"
                    (click)="assignbulkRep()"
                    *ngIf="assigned !== 'newsletter'"
                    [disabled]="bulk.length === 0"
                  >
                    <span class="gts-btn-icon">person_add</span>
                  </button>

                  <button
                    class="gts-btn-primary-outline-actions-end"
                    matRipple
                    matTooltip="Delete Selected Leads"
                    *ngIf="assigned !== 'newsletter'"
                    (click)="borrarBulk()"
                    [disabled]="bulk.length === 0"
                  >
                    <span class="gts-btn-icon">delete</span>
                  </button>

                  <button
                    class="gts-btn-primary-outline-actions-end"
                    matRipple
                    *ngIf="assigned == 'newsletter'"
                    (click)="deleteBulkNews()"
                    [disabled]="bulkNewsletterContacts.length === 0"
                  >
                    <span class="gts-btn-icon">delete</span>
                  </button>
                </div>
              </section>

              <!-- TABLE -->
              <section style="margin-top: 0px">
                <div>
                  <!-- <div style="display: flex; justify-content: flex-end;">

                      <button class="gts-btn-primary-outline-actions-start" matRipple       
                        matRippleColor="rgba(156, 39, 176, .2)">
                        <span class="gts-btn-icon">table_view</span>
                      </button>
                      
                      <button class="gts-btn-primary-outline-actions" matRipple       
                        matRippleColor="rgba(156, 39, 176, .2)">
                        <span class="gts-btn-icon">picture_as_pdf</span>
                      </button>

                      <button class="gts-btn-primary-outline-actions" matRipple       
                        matRippleColor="rgba(156, 39, 176, .2)">
                        <span class="gts-btn-icon">print</span>
                      </button>

                      <button class="gts-btn-primary-outline-actions" matRipple       
                        matRippleColor="rgba(156, 39, 176, .2)">
                        <span class="gts-btn-icon">view_column</span>
                      </button>

                      <button class="gts-btn-primary-outline-actions-end" matRipple       
                        matRippleColor="rgba(156, 39, 176, .2)">
                        <span class="gts-btn-icon">sync_alt</span>
                      </button>

                    </div> -->

                  <div [ngClass]="getClassConta()">
                    <div *ngIf="searching" style="text-align: center">
                      <h2>
                        <b
                          ><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i
                          >Loading...</b
                        >
                      </h2>
                    </div>
                    <dinamic-table
                      *ngIf="assigned == 'newsletter' && !searching"
                      [id]="'newsletter2'"
                      [data]="dataNewsletter"
                      [columnfilters]="filtrosnews"
                      [campoBusqueda]="campoBusqueda"
                      [perPage]="itemsPorPagina"
                      [page]="paginaActual"
                      [total_items_count]="totalItems"
                      [total_pages]="totalPaginas"
                      [bulk]="bulkNewsletterContacts"
                      (buscar)="getNewsletterContacts($event, false)"
                      (action_button)="actionNews($event)"
                      (toggleButtons)="onToggleButtons($event)"
                      (rightClickAction)="handleRightClick($event)" 
                    ></dinamic-table>
                    <dinamic-table
                      *ngIf="assigned !== 'newsletter' && !searching"
                      [id]="'unassigned2'"
                      [data]="dataUnassigned"
                      [columnfilters]="filtros"
                      [campoBusqueda]="campoBusqueda"
                      [perPage]="itemsPorPagina"
                      [page]="paginaActual"
                      [total_items_count]="totalItems"
                      [total_pages]="totalPaginas"
                      [bulk]="bulk"
                      (buscar)="getAllContactsFormByDate($event, false)"
                      [config]="options"
                      (action_button)="actions($event)"
                      (newConfig)="updateConfig($event)"
                      [sort]="[[9, 'desc']]"
                      (toggleButtons)="onToggleButtons($event)"
                      (rightClickAction)="handleRightClick($event)" 
                    ></dinamic-table>
                  </div>
                </div>
              </section>
            </div>

            <!-- BTN FLOAT -->
            <!-- <section style="background-color: #208b2979;">
              <div style="display: flex; gap: 8px;">
                <button>Status</button>
                <button>SEARCH</button>
                <button>SEARCH</button>
              </div>
            </section> -->

            <!-- TABLE -->
            <!-- <section style="background-color: #8b2020;">
              <div>
                <P>
                  Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint accusamus ipsa ipsam quos consectetur explicabo, aspernatur sapiente delectus officiis molestiae fuga sed asperiores, dicta consequuntur ut, reprehenderit quibusdam omnis nesciunt?
                </P>
              </div>
            </section> -->
          </div>
          <!------------------------ END CARD-BODY -------------------->
        </div>
      </div>
    </div>
  </div>
</div>
<!-- END REDESING -->

<div class="main-content" *ngIf="!newUI">
  <!-- OLD DESING -->
  <div class="container-fluid">
    <div style="float: right; margin-right: 20px" class="row">
      <button (click)="openModal()" mat-raised-button class="btn btn-success">
        <span class="btn-label">
          <i class="material-icons">add</i>
        </span>
        New Contact
      </button>
    </div>

    <div class="clearfix"></div>

    <div class="card">
      <div class="card-header card/-header-primary card-header-icon">
        <div class="card-icon">
          <i class="material-icons">assignment</i>
        </div>
        <h4 class="card-title">Leads</h4>
      </div>
      <div class="card-body">
        <div class="toolbar">
          <!-- <div class="row">
            <div class="col-3">
              <mat-form-field class="example-full-width has-label">
                  <input type="text" name="search" [(ngModel)]="buscar" matInput id="search" placeholder="Name">
              </mat-form-field>
            </div>
            <div class="col-2">
              <button class="btn btn-warning btn-sm"><i class="fa fa-search" aria-hidden="true"></i></button>
            </div>
          </div> -->

          <div class="row">
            <div class="col-6">
              <button
                class="btn btn-primary btn-md"
                (click)="hdmode()"
                title="Holidays Mode Configuration"
              >
                <i class="fa fa-cog" aria-hidden="true"></i> &nbsp; HD Mode
              </button>
            </div>
            <div class="col-md-6" style="text-align: right">
              <button
                *ngIf="assigned !== 'newsletter'"
                class="btn btn-info btn-md"
                (click)="assignbulkRep()"
                [disabled]="bulk.length === 0"
              >
                Assign Selected Leads ({{ bulk.length }})
              </button>

              &nbsp;

              <button
                *ngIf="assigned !== 'newsletter'"
                class="btn btn-danger btn-md"
                (click)="borrarBulk()"
                [disabled]="bulk.length === 0"
              >
                Delete Selected Leads ({{ bulk.length }})
              </button>

              &nbsp;

              <button
                *ngIf="assigned == 'newsletter'"
                class="btn btn-danger btn-md"
                (click)="deleteBulkNews()"
                [disabled]="bulkNewsletterContacts.length === 0"
              >
                Delete Selected Newsletter Contacts ({{
                  bulkNewsletterContacts.length
                }})
              </button>
            </div>
          </div>

          <div class="row">
            <div class="col-md-5" style="margin-top: 20px">
              <button
                [ngClass]="{
                  'btn-warning': assigned == 'all',
                  'btn-outline-warning': assigned != 'all'
                }"
                class="btn btn-sm"
                (click)="cambiar('all')"
                [disabled]="assigned == 'all'"
                style="border-radius: 45px"
              >
                All
              </button>

              &nbsp;&nbsp;

              <button
                [ngClass]="{
                  'btn-warning': assigned == 'assigned',
                  'btn-outline-warning': assigned != 'assigned'
                }"
                class="btn btn-sm"
                (click)="cambiar('assigned')"
                [disabled]="assigned == 'assigned'"
                style="border-radius: 45px"
              >
                Assigned
              </button>

              &nbsp;&nbsp;

              <button
                [ngClass]="{
                  'btn-warning': assigned == 'unassigned',
                  'btn-outline-warning': assigned != 'unassigned'
                }"
                class="btn btn-sm"
                (click)="cambiar('unassigned')"
                [disabled]="assigned == 'unassigned'"
                style="border-radius: 45px"
              >
                Unassigned
              </button>

              &nbsp;&nbsp;

              <button
                [ngClass]="{
                  'btn-warning': assigned == 'blacklist',
                  'btn-outline-warning': assigned != 'blacklist'
                }"
                class="btn btn-sm"
                (click)="cambiar('blacklist')"
                [disabled]="assigned == 'blacklist'"
                style="border-radius: 45px"
              >
                BlackList
              </button>
              &nbsp;&nbsp;

              <button
                [ngClass]="{
                  'btn-warning': assigned == 'newsletter',
                  'btn-outline-warning': assigned != 'newsletter'
                }"
                class="btn btn-sm"
                (click)="cambiar('newsletter')"
                [disabled]="assigned == 'newsletter'"
                style="border-radius: 45px"
              >
                News Letter Contacts
              </button>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="bmd-label-floating">Since:</label>
                <input
                  type="date"
                  class="form-control"
                  name="since"
                  #since="ngModel"
                  [(ngModel)]="sinceDate"
                  required
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="bmd-label-floating">To:</label>
                <input
                  type="date"
                  class="form-control"
                  name="to"
                  #to="ngModel"
                  [(ngModel)]="toDate"
                  required
                />
              </div>
            </div>
            <div class="col-md-1">
              <button
                style="margin-top: 40px"
                class="btn btn-warning btn-sm"
                (click)="getAllContactsFormByDate()"
                [disabled]="sinceDate == null || searching"
              >
                <i
                  *ngIf="!searching"
                  class="fa fa-search"
                  aria-hidden="true"
                ></i>
                <i
                  *ngIf="searching"
                  class="fa fa-refresh fa-spin fa-3x fa-fw"
                ></i>
              </button>
            </div>
          </div>
        </div>
        <br />

        <div class="row">
          <div class="col-md-12">
            <div *ngIf="searching" style="text-align: center">
              <h2>
                <b
                  ><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                  Loading...</b
                >
              </h2>
            </div>
            <!-- <app-contact-table
              *ngIf="
                !searching && (assigned == 'all' || assigned == 'blacklist')
              "
              [assigned]="true"
              [options]="options"
              (newOptions)="updateConfig($event)"
              [elements]="contactFormsAll"
              [blacklist]="assigned == 'blacklist'"
              (out)="accion($event)"
              [bulk]="bulk"
              (changeBulk)="checado($event)"
            >
            </app-contact-table> -->
            <!-- <dinamic-table
                *ngIf="assigned == 'newsletter' && !searching"
                [id]="'newsletter'"
                [frontpaginate]="true"
                [data]="dataNewsletter"
                (action_button)="actionNews($event)"
                [bulk]="bulkNewsletterContacts"
                [page]="paginaActual"
                [total_items_count]="totalItems"
              ></dinamic-table>
              <dinamic-table
                *ngIf="assigned !== 'newsletter' && !searching"
                [id]="'unassigned'"
                [data]="dataUnassigned"
                [frontpaginate]="true"
                (action_button)="actions($event)"
                [bulk]="bulk"
                [sort]="[[7, 'desc']]"
              ></dinamic-table> -->
            <!-- <app-contact-table
              *ngIf="!searching && assigned == 'unassigned'"
              [elements]="contactFormsUnassigned"
              [options]="options"
              (newOptions)="updateConfig($event)"
              (out)="accion($event)"
              [bulk]="bulk"
              (changeBulk)="checado($event)"
            ></app-contact-table> -->

            <!-- <app-contact-table
              *ngIf="!searching && assigned == 'assigned'"
              [assigned]="true"
              [options]="options"
              (newOptions)="updateConfig($event)"
              [elements]="contactFormsAssigned"
              (out)="accion($event)"
              [bulk]="bulk"
              (changeBulk)="checado($event)"
            >
            </app-contact-table> -->
          </div>
        </div>
      </div>
      <!-- end content-->
    </div>
    <!--  end card  -->
  </div>
</div>

<!-- MODAL - HB MODE OK -->
<div
  class="modal fade"
  id="hdModal"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  data-keyboard="false"
>
  <!-- MODAL - HB MODE OK -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Holidays Mode</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <section>
          <div *ngIf="!statusHDMode" class="itad-status-container">
            <span class="itad-status-circle itad-inactive"></span>
            Inactive
          </div>

          <div *ngIf="statusHDMode" class="itad-status-container">
            <span class="itad-status-circle itad-active"></span>
            Active
          </div>
        </section>

        <div>
          <h3 class="itad-card-title-2">Time Off Schedule</h3>
        </div>

        <section *ngIf="totalHDModeRecords === 0" style="text-align: center">
          <img
            src="/assets/img/noVacationSchedule.svg"
            alt="noVacationSchedule"
            width="250px"
          />
        </section>

        <mat-progress-bar
          style="width: 100%"
          *ngIf="loadingTableHDMode"
          mode="indeterminate"
        ></mat-progress-bar>

        <section *ngIf="totalHDModeRecords > 0">
          <dinamic-table
            *ngIf="!loadingTableHDMode"
            [id]="'tableHDMode'"
            [frontpaginate]="true"
            [data]="dataHDMode"
            (action_button)="actionsHDMode($event)"
            [total_items_count]="totalHDModeRecords"
          ></dinamic-table>
        </section>

        <section style="margin-bottom: 16px">
          <button
            class="gts-btn-primary-basic"
            matRipple
            (click)="showFormHDMode('New')"
            [disabled]="titleFormHDMode === 'Edit'"
          >
            <span class="gts-btn-icon-left" *ngIf="!formHDModeVisible"
              >add</span
            >
            <span class="gts-btn-icon-left" *ngIf="formHDModeVisible"
              >remove</span
            >
            <span class="gts-btn-text">{{ titleFormHDMode }} Time Off</span>
          </button>
        </section>

        <mat-progress-bar
          style="width: 100%"
          *ngIf="loadingFormTimeOff"
          mode="indeterminate"
        ></mat-progress-bar>

        <section *ngIf="!loadingFormTimeOff && formHDModeVisible">
          <div class="layout-form-hd-mode">
            <mat-form-field appearance="fill">
              <mat-label>Holidays Type</mat-label>
              <mat-select
                name="typeHolidaysLeads"
                [(ngModel)]="timeOffForm.assignmentType"
                required
              >
                <mat-option value="Rep">Rep</mat-option>
                <mat-option value="Random">Random</mat-option>
              </mat-select>
            </mat-form-field>
            <!-- IF RAMDOM -->
            <mat-form-field
              appearance="fill"
              *ngIf="timeOffForm.assignmentType === 'Random'"
            >
              <mat-label>Select role(s) for pickup random rep</mat-label>
              <mat-select
                [formControl]="toppings"
                [(ngModel)]="selectedValues"
                multiple
              >
                <mat-select-trigger>
                  {{ toppings.value ? pipeRep(toppings.value[0]) : "" }}
                  <span
                    *ngIf="toppings.value?.length > 1"
                    class="example-additional-selection"
                  >
                    (+{{ toppings.value.length - 1 }}
                    {{ toppings.value?.length === 2 ? "other" : "others" }})
                  </span>
                </mat-select-trigger>
                <mat-option
                  *ngFor="let topping of toAssagn"
                  [value]="topping"
                  >{{ pipeRep(topping) }}</mat-option
                >
              </mat-select>
            </mat-form-field>
            <!-- IF REP -->
            <!-- {{formHDModeVisible}} {{titleFormHDMode}} -->
            <mat-form-field
              appearance="fill"
              *ngIf="timeOffForm.assignmentType === 'Rep'"
            >
              <mat-label>Select Rep(s) </mat-label>
              <mat-select
                [formControl]="reps"
                [(ngModel)]="selectedReps"
                multiple
              >
                <mat-select-trigger>
                  <!-- {{ rep}} -->
                  {{ reps.value?.length > 0 ? pipeReps(reps.value[0]) : "" }}
                  <span
                    *ngIf="reps.value?.length > 1"
                    class="example-additional-selection"
                  >
                    (+{{ reps.value.length - 1 }}
                    {{ reps.value?.length === 2 ? "other" : "others" }})
                  </span>
                </mat-select-trigger>
                <mat-option
                  *ngFor="let rep of reptoAssagn"
                  [value]="titleFormHDMode == 'Edit' ? rep.id : rep"
                  >{{ rep.name }} {{ rep.surname }}</mat-option
                >
              </mat-select>
            </mat-form-field>
            <!-- Type -->
            <mat-form-field appearance="fill">
              <mat-label>Type</mat-label>
              <mat-select name="type" required [(ngModel)]="timeOffForm.type">
                <mat-option value="bydate">By date</mat-option>
                <mat-option value="permanent">Permanent </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>Websites</mat-label>
              <mat-select name="type" required [(ngModel)]="timeOffForm.applyTo">
                <mat-option value="">Please select an option</mat-option>
                <mat-option value="Main MX">Main MX </mat-option>
                <mat-option value="Main USA">Main USA </mat-option>
                <mat-option value="Cities MX">Cities MX </mat-option>
                <mat-option value="Cities USA">Cities USA </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="none md:block"></div>
          </div>
          <div
            class="layout-form-hd-mode"
            *ngIf="timeOffForm.type === 'bydate'"
          >
            <mat-form-field appearance="fill">
              <mat-label>Time Off Start Date</mat-label>
              <input
                matInput
                [matDatepicker]="startDate"
                [(ngModel)]="timeOffForm.startDate"
              />
              <mat-hint>MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle
                matSuffix
                [for]="startDate"
              ></mat-datepicker-toggle>
              <mat-datepicker #startDate></mat-datepicker>
            </mat-form-field>

            <div class="itad-mat-form-field">
              <label for="hrInicio" class="itad-mat-label">Start Time</label>
              <input
                id="hrInicio"
                type="time"
                class="itad-mat-input"
                [(ngModel)]="timeOffForm.hrInicio"
              />
            </div>

            <mat-form-field appearance="fill">
              <mat-label>Return Date</mat-label>
              <input
                matInput
                [matDatepicker]="endDate"
                [(ngModel)]="timeOffForm.endDate"
              />
              <mat-hint>MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle
                matSuffix
                [for]="endDate"
              ></mat-datepicker-toggle>
              <mat-datepicker #endDate></mat-datepicker>
            </mat-form-field>

            <div class="itad-mat-form-field">
              <label for="hrFin" class="itad-mat-label">End Time</label>
              <input
                id="hrFin"
                type="time"
                class="itad-mat-input"
                [(ngModel)]="timeOffForm.hrFin"
              />
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer" *ngIf="formHDModeVisible">
        <!-- NEW -->
        <div class="container-buttons-right">
          <button
            class="gts-btn-primary-outline"
            matRipple
            (click)="resetTimeOffForm()"
          >
            <span class="gts-btn-text">Cancel</span>
          </button>

          <button
            [disabled]="isButtonDisabled()"
            class="gts-btn-primary"
            matRipple
            (click)="postTimeOff()"
            *ngIf="titleFormHDMode === 'New'"
          >
            <i
              class="fa fa-circle-o-notch fa-spin fa-1x fa-fw"
              *ngIf="loadingFormTimeOff"
            ></i>
            <span class="gts-btn-text">Save</span>
          </button>

          <!-- EDIT -->
          <button
            [disabled]="isButtonDisabled()"
            class="gts-btn-primary"
            matRipple
            (click)="updateHDMode()"
            *ngIf="titleFormHDMode === 'Edit'"
          >
            <i
              class="fa fa-circle-o-notch fa-spin fa-1x fa-fw"
              *ngIf="loadingFormTimeOff"
            ></i>
            <span class="gts-btn-text">Save changes</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- CREATE  OK-->
<div
  class="modal fade"
  id="crudModal"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  data-keyboard="false"
>
  <!-- CREATE  OK-->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <b>{{ action == "create" ? "Create New" : "Delete" }} Lead</b>
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <!-- BODY 1 -->

      <div
        *ngIf="guardando || cargando"
        style="text-align: center"
        class="modal-body"
      >
        <div *ngIf="cargando">
          <h2>
            <b><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> Loading...</b>
          </h2>
        </div>
        <div *ngIf="guardando">
          <h2>
            <b><i class="fa fa-refresh fa-spin fa-3x fa-fw"></i> Saving...</b>
          </h2>
        </div>
      </div>

      <!-- BODY  2-->
      <div *ngIf="!guardando && !cargando">
        <div class="modal-body">
          <form #f="ngForm">
            <!-- <div *ngIf="action != 'delete'" class="input-group"> -->
            <div *ngIf="action != 'delete'">
              <div>
                <h5
                  style="
                    font-weight: bold;
                    font-size: 16px;
                    font-family: 'Roboto';
                  "
                >
                  Contact info
                </h5>
              </div>
              <div class="layout-form-x3">
                <div>
                  <!-- <mat-form-field appearance="fill">
                    <mat-label>Favorite food</mat-label>
                    <input matInput placeholder="Ex. Pizza" value="Sushi">
                  </mat-form-field> -->

                  <mat-form-field>
                    <mat-label>Contact name</mat-label>
                    <input
                      type="text"
                      name="contact"
                      [(ngModel)]="newLead.name"
                      matInput
                      id="contact"
                      [disabled]="action == 'read'"
                      required
                    />
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field>
                    <mat-label>Company</mat-label>
                    <input
                      type="text"
                      name="company"
                      [(ngModel)]="newLead.company"
                      matInput
                      id="company"
                      [disabled]="action == 'read'"
                      required
                    />
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field>
                    <mat-label>Email</mat-label>
                    <input
                      type="email"
                      name="mail"
                      [(ngModel)]="newLead.email"
                      matInput
                      id="mail"
                      [disabled]="action == 'read'"
                      required
                    />
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field>
                    <mat-label>Phone</mat-label>
                    <input
                      type="number"
                      name="phone"
                      [(ngModel)]="newLead.phone"
                      matInput
                      id="phone"
                      maxlength="10"
                      [disabled]="action == 'read'"
                      required
                    />
                  </mat-form-field>
                </div>

                <!-- <div>
                  <mat-form-field >
                    <input
                      type="text"
                      name="location"
                      [(ngModel)]="newLead.location"
                      matInput
                      id="location"
                      placeholder="Location"
                      [disabled]="action == 'read'"
                    />
                  </mat-form-field>
                </div> -->

                <div>
                  <mat-form-field appearance="fill">
                    <mat-label>Source</mat-label>
                    <mat-select
                      name="source"
                      #source="ngModel"
                      matNativeControl
                      [(ngModel)]="newLead.source"
                    >
                      <mat-option
                        *ngFor="let source of sources"
                        value="{{ source }}"
                      >
                        {{ source }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <h5
                style="
                  font-weight: bold;
                  font-size: 16px;
                  font-family: 'Roboto';
                  margin-top: 16px;
                "
              >
                Equipment Location
              </h5>

              <!-- <div class="layoud-form-x3">

                <mat-form-field appearance="fill">
                  <mat-label>Country</mat-label>
                  <mat-select [(ngModel)]="newLead.country_id" (selectionChange)="getStates()">
                    <mat-option *ngFor="let country of countries" [value]="country.id">{{ country.country }}</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="fill">
                  <mat-label>State</mat-label>
                  <mat-select [(ngModel)]="newLead.state_id" (selectionChange)="getCities()">
                    <mat-option *ngFor="let state of states" [value]="state.id">{{ state.state }}</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="fill">
                  <mat-label>City</mat-label>
                  <mat-select [(ngModel)]="newLead.city_id">
                    <mat-option *ngFor="let city of cities" [value]="city.id">{{ city.city }}</mat-option>
                  </mat-select>
                </mat-form-field>

              </div> -->

              <div class="layout-form-x3">
                <!-- Country Select -->
                <mat-form-field appearance="fill">
                  <mat-label>Country</mat-label>
                  <mat-select
                    [(ngModel)]="newLead.country_id"
                    (selectionChange)="getStates()"
                  >
                    <mat-option
                      *ngFor="let country of countries"
                      [value]="country.id"
                      >{{ country.country }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>

                <!-- State Autocomplete -->
                <mat-form-field appearance="fill">
                  <mat-label>State</mat-label>
                  <input
                    type="text"
                    matInput
                    [matAutocomplete]="autoState"
                    [formControl]="stateControl"
                  />
                  <mat-autocomplete
                    #autoState="matAutocomplete"
                    (optionSelected)="onStateSelected($event)"
                  >
                    <mat-option
                      *ngFor="let state of filteredStates | async"
                      [value]="state.state"
                    >
                      {{ state.state }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>

                <!-- City Autocomplete -->
                <mat-form-field appearance="fill">
                  <mat-label>City</mat-label>
                  <input
                    type="text"
                    matInput
                    [matAutocomplete]="autoCity"
                    [formControl]="cityControl"
                  />
                  <mat-autocomplete
                    #autoCity="matAutocomplete"
                    (optionSelected)="onCitySelected($event)"
                  >
                    <mat-option
                      *ngFor="let city of filteredCities | async"
                      [value]="city.city"
                    >
                      {{ city.city }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>

              <div>
                <mat-form-field class="example-full-width has-label">
                  <mat-label>Description</mat-label>
                  <textarea
                    name="descripcion"
                    id="descripcion"
                    [(ngModel)]="newLead.descripcion"
                    matInput
                    [disabled]="action == 'read'"
                  ></textarea>
                </mat-form-field>
              </div>
            </div>

            <div *ngIf="action == 'delete'">
              <h6>
                <b
                  ><i
                    class="fa fa-exclamation-triangle"
                    style="color: 'red'"
                    aria-hidden="true"
                  ></i>
                  Are you sure you want to delete this lead?
                </b>
              </h6>
            </div>
          </form>
        </div>

        <!-- FOOTER -->
        <div class="modal-footer">
          <!-- <button
            type="button"
            class="btn btn-danger btn-lg btn-block"
            (click)="end(f)"
          >
            {{ action == "read" ? "Close" : "Cancel" }}
          </button> -->
          <!-- &nbsp;&nbsp; -->
          <!-- <button
            *ngIf="action != 'read'"
            type="button"
            class="btn btn-primary btn-lg btn-block"
            (click)="guardar(f)"
            [disabled]="!f.valid"
          >
            {{ action == "delete" ? "Continue" : "Save" }}
          </button> -->

          <button
            class="gts-btn-primary"
            matRipple
            (click)="guardar(f)"
            [disabled]="!f.valid"
            *ngIf="action != 'read'"
          >
            <span class="gts-btn-text">
              {{ action == "delete" ? "Continue" : "Create New Lead" }}</span
            >
          </button>

          <!-- <button *ngIf="action == 'read'" type="button" class="btn btn-warning btn-lg btn-block" (click)="action = 'update'">
                    Edit
                </button> -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- MODAL UNASSIGN | OK -->
<div
  class="modal fade"
  id="removeModal"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Unassign the rep</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <h5>
          Are you sure you want to unassign this lead from this purchasing rep?
        </h5>
      </div>

      <div class="modal-footer">
        <button class="gts-btn-primary-outline" matRipple (click)="close()">
          <span class="gts-btn-text"> Cancel </span>
        </button>
        &nbsp;&nbsp;
        <button
          class="gts-btn-primary"
          matRipple
          (click)="remove()"
          [disabled]="guardando"
        >
          <i
            *ngIf="guardando"
            class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"
          ></i>
          <span class="gts-btn-text"> Continue </span>
        </button>

        <!-- <button
          type="button"
          class="btn btn-danger btn-lg btn-block"
          (click)="close()"
        >
          Cancel
        </button> -->
        <!-- &nbsp;&nbsp;
        <button
          type="button"
          class="btn btn-primary btn-lg btn-block"
          (click)="remove()"
          [disabled]="guardando"
        >
          <i
            *ngIf="guardando"
            class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"
          ></i>
          Continue
        </button> -->
      </div>
    </div>
  </div>
</div>

<!-- Assign to rep myModal UNIQUE | OK -->
<div
  class="modal fade"
  id="myModal"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Assign to rep</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <form>
          <mat-form-field appearance="fill">
            <mat-label>Select a rep</mat-label>
            <mat-select
              name="rep_id"
              [(ngModel)]="repId"
              #rep_id="ngModel"
              required
            >
              <mat-option *ngFor="let rep of repsList" [value]="rep.id"
                >{{ rep.name }} {{ rep.surname }}</mat-option
              >
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Comments</mat-label>
            <textarea
              matInput
              placeholder="Comments..."
              name="comments"
              id="comments"
              [(ngModel)]="comentarios"
              [disabled]="action == 'read'"
              rows="5"
            ></textarea>
          </mat-form-field>
        </form>

        <!-- <form>
          <div class="form-group">
            <label class="bmd-label-floating">select a rep</label>
            <select
              name="rep_id"
              [(ngModel)]="repId"
              #rep_id="ngModel"
              placeholder="Client Name"
              class="form-control"
              required
            >
              <option value="null" disabled>please select an ocpion</option>
              <option *ngFor="let rep of repsList" [value]="rep.id">
                {{ rep.name }} {{ rep.surname }}
              </option>
            </select>
          </div>

          <mat-form-field class="example-full-width has-label">
            <textarea
              name="comments"
              id="comments"
              [(ngModel)]="comentarios"
              matInput
              cols="30"
              rows="5"
              placeholder="Comments"
              [disabled]="action == 'read'"
            ></textarea>
          </mat-form-field>
        </form> -->
      </div>

      <div class="modal-footer" style="text-align: center">
        <button
          class="gts-btn-primary"
          matRipple
          (click)="save()"
          [disabled]="repId == '' || guardando"
        >
          <i
            *ngIf="guardando"
            class="fa fa-circle-o-notch fa-spin fa-1x fa-fw"
          ></i>
          <span class="gts-btn-text">Save</span>
        </button>

        <!-- <button
          type="button"
          class="btn btn-danger btn-lg btn-block"
          (click)="close()"
        >
          Cancel
        </button>
        &nbsp;&nbsp;
        <button
          type="button"
          class="btn btn-primary btn-lg btn-block"
          (click)="save()"
          [disabled]="repId == '' || guardando"
        >
          <i
            *ngIf="guardando"
            class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"
          ></i>
          Save
        </button> -->
      </div>
    </div>
  </div>
</div>

<!-- Assign to rep assignBulkModal MULTIPLE | OK -->
<div
  class="modal fade"
  id="assignBulkModal"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          Assign {{ bulk.length }} {{ bulk.length === 1 ? "lead" : "leads" }} to
          rep
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <form>
          <mat-form-field appearance="fill">
            <mat-label>Select a rep</mat-label>
            <mat-select
              name="rep_id"
              [(ngModel)]="repId"
              #rep_id="ngModel"
              required
            >
              <mat-option *ngFor="let rep of repsList" [value]="rep.id"
                >{{ rep.name }} {{ rep.surname }}</mat-option
              >
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Comments</mat-label>
            <textarea
              matInput
              placeholder="Comments..."
              name="comments"
              id="comments"
              [(ngModel)]="comentarios"
              [disabled]="action == 'read'"
              rows="5"
            ></textarea>
          </mat-form-field>
        </form>

        <!-- <form>
          <div class="form-group">


            <label class="bmd-label-floating">Select a rep</label>
            <select
              name="rep_id"
              [(ngModel)]="repId"
              #rep_id="ngModel"
              placeholder="Client Name"
              class="form-control"
              required
            >
              <option value="null" disabled>please select an ocpion</option>
              <option *ngFor="let rep of repsList" [value]="rep.id">
                {{ rep.name }} {{ rep.surname }}
              </option>
            </select>
          </div>

          <mat-form-field class="example-full-width has-label">
            <label class="bmd-label-floating">Comments</label>
            <textarea
              name="comments"
              id="comments"
              [(ngModel)]="comentarios"
              matInput
              cols="30"
              rows="5"
              placeholder="Comments"
              [disabled]="action == 'read'"
            ></textarea>
          </mat-form-field>
        </form> -->
      </div>

      <div class="modal-footer" style="text-align: center">
        <button
          class="gts-btn-primary"
          matRipple
          (click)="saveassignbulkRep()"
          [disabled]="repId == '' || asignando"
        >
          <i
            *ngIf="asignando"
            class="fa fa-circle-o-notch fa-spin fa-1x fa-fw"
          ></i>
          <span class="gts-btn-text">Save</span>
        </button>

        <!-- <button
          type="button"
          class="btn btn-danger btn-lg btn-block"
          (click)="finassignbulkRep()"
        >
          Cancel
        </button>
        &nbsp;&nbsp;
        <button
          type="button"
          class="btn btn-primary btn-lg btn-block"
          (click)="saveassignbulkRep()"
          [disabled]="repId == '' || asignando"
        >
          <i *ngIf="!asignando" class="fa fa-floppy-o" aria-hidden="true"></i>
          <i
            *ngIf="asignando"
            class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"
          ></i>
          &nbsp; Save
        </button> -->
      </div>
    </div>
  </div>
</div>

<!-- <div
  class="modal fade"
  id="borrarBulkModal"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header" style="text-align: center">
        <div>
          <h2>
            <i class="fa fa-fw fa-warning fa-lg text-danger"></i
            ><b> You are about to remove the following elements:</b>
          </h2>
          <br />
        </div>
      </div>

      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <table width="100%">
              <thead>
                <th>ID</th>
                <th>/ Name</th>
                <th>/ Phone</th>
                <th>/ Email</th>
                <th>/ Date</th>
              </thead>
              <tbody *ngFor="let row of borrarElementos">
                <td>{{ row[0] }}</td>
                <td>
                  / {{ row[1] | slice : 0 : 20
                  }}{{ row[1].length > 20 ? "..." : "" }}
                </td>
                <td>/ {{ row[2] }}</td>
                <td>
                  / {{ row[3] | slice : 0 : 20
                  }}{{ row[3].length > 20 ? "..." : "" }}
                </td>
                <td>/ {{ row[5] * 1000 | date : "MM-dd-yyyy" }}</td>
              </tbody>
            </table>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12" style="text-align: center; margin-top: 20px">
            <h3><b>Are you sure to continue?</b></h3>
            <br />
          </div>
        </div>
      </div>

      <div class="modal-footer" style="text-align: center">
        <button
          type="button"
          class="btn btn-default btn-lg btn-block"
          (click)="finborrarBulk()"
        >
          Cancel
        </button>
        &nbsp;&nbsp;
        <button
          type="button"
          class="btn btn-danger btn-lg btn-block"
          (click)="borrandoBulk()"
          [disabled]="borrando"
        >
          <i *ngIf="!borrando" class="fa fa-floppy-o" aria-hidden="true"></i>
          <i
            *ngIf="borrando"
            class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"
          ></i>
          &nbsp; Delete
        </button>
      </div>
    </div>
  </div>
</div> -->
